'use client';

import React from 'react';
import { motion } from 'framer-motion';
import { BackgroundBeams } from '@/components/BackgroundBeams';
import CardProcessingSolutionsCards from '@/components/CardProcessingSolutionsCards';
import { useLanguage } from '@/context/LanguageContext';
import { EditableContent } from "@/components/EditableContent";

export default function PaymentSolutionsPage() {
  const { isRTL } = useLanguage();
  
  const solutionData = [
    {
      titleId: "payment.device.mini.title",
      descriptionId: "payment.device.mini.description",
      img: "/images/img-solutions-mini-Payment-Device.webp",
      link: "/services/payment-solutions/super-compact-smart-payment-device"
    },
    {
      titleId: "payment.device.compact.title",
      descriptionId: "payment.device.compact.description",
      img: "/images/630372b942360420fb4cecd0.webp",
      link: "/services/payment-solutions/compact-smart-payment-device"
    },
    {
      titleId: "payment.device.smart.title",
      descriptionId: "payment.device.smart.description",
      img: "/images/SmartPayment-device.webp",
      link: "/services/payment-solutions/smart-payment-device"
    }
  ];

  return (
    <div className="min-h-screen bg-white dark:bg-gray-950" dir={isRTL ? 'rtl' : 'ltr'}>
      {/* Hero Section with Background Beams */}
      <div className="min-h-[70vh] relative flex items-center justify-center">
        <BackgroundBeams />
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 pt-32">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-4xl mx-auto text-center"
          >
            <div className='flex flex-col items-center mb-5'>
              <p className='text-xl font-bold text-black dark:text-white mb-3'>
                <EditableContent id="payment.hero.subtitle" />
              </p>
              <div className="w-32 h-0.5 bg-gradient-to-r from-[#ED2245] to-[#ED2245]/60 rounded-full"></div>
            </div>
            
            <h1 className="text-5xl md:text-6xl font-bold text-[#ED2245] mb-8 justify-center text-center flex">
              <EditableContent id="payment.hero.title" />
            </h1>
            
            <h2 className="text-xl font-bold text-[#ED2245] mb-5 justify-center mt-8">
              <EditableContent id="payment.hero.subtitle2" />
            </h2>
            
            <p className="text-lg text-black dark:text-white leading-relaxed mb-8">
              <EditableContent id="payment.hero.description" />
            </p>
          </motion.div>
        </div>
      </div>
      
      {/* Payment Solutions Cards */}
      <section className="relative overflow-hidden" id="culture">
        <CardProcessingSolutionsCards
          titleId="payment.explore"
          learnMoreTextId="payment.learn_more"
          data={solutionData}
        />
      </section>
    </div>
  );
}
